import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react"
import { api, json, tokenStore } from "./api"

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!tokenStore.get()) {
      setLoading(false)
      return
    }

    api("/auth/me")
      .then(setSession)
      .catch(() => tokenStore.clear())
      .finally(() => setLoading(false))
  }, [])

  const authenticate = useCallback(async (path, values) => {
    const payload = await api(path, json("POST", values))
    tokenStore.set(payload.token)
    setSession({ user: payload.user, coach: payload.coach, backend_migration: payload.backend_migration })
  }, [])

  const logout = useCallback(async () => {
    try {
      await api("/auth/logout", { method: "DELETE" })
    } finally {
      tokenStore.clear()
      setSession(null)
    }
  }, [])

  const refreshSession = useCallback(async () => setSession(await api("/auth/me")), [])

  const value = useMemo(() => ({
    session,
    loading,
    login: (values) => authenticate("/auth/login", values),
    register: (values) => authenticate("/auth/register", values),
    refreshSession,
    logout,
  }), [authenticate, loading, logout, refreshSession, session])

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
  return useContext(AuthContext)
}
